/*
 * itrace监控接入https://wpk-intl.ucweb.com/index
 */

import { createMonitorInstance, safeParseJson } from '@ali/lark-lib-monitor';
import { getQueryStringByName } from '@/utils';

// bid
const PRE_BID = 'ma6w9cac-t1jsns6q'; // 预发
const PRO_BID = 'ya60pvn1-y74hr94i'; // 生产

// 获取环境 ICE_EXE_ENV
const env = process.env.ICE_EXE_ENV;
const version = process.env.ICE_APP_VERSION;

const isDevEnvironment = () => process.env.NODE_ENV === 'development';
const isProd = ['uat', 'release', 'production'].includes(env);
const isSetReady = ['pre', 'uat', 'release', 'production'].includes(env);

const channelCode = getQueryStringByName('wapid');
const localStorage = window.localStorage.getItem(`${channelCode}_baseObj`) || '{}';
const localStorageJson = safeParseJson(localStorage) || {};
const accountId = localStorageJson.state?.baseObj?.user?.account?.accountId;
const canvasId = window.localStorage.getItem(`${channelCode}_canvasId`);

const initItrace = () => {
  const bid = isProd ? PRO_BID : PRE_BID;
  const options = {
    bid,
    uid: accountId || canvasId || 'unknown',
    cluster: 'intl',
    rel: version || 'unknown',
    // debug: true, // 刚接入或者定位上报问题时可打开debug来获取更多sdk的运行信息
    beforeSendHandle(logData) {
      if (isDevEnvironment()) {
        // 本地开发环境不上报
        return false;
      }
      return logData;
    },
    spa: true,
    apiBeforeSend(logData) {
      const res = safeParseJson(logData.w_resp);
      /**
       * c4 字段表示请求状态码
       * c5 字段表示错误信息 message
       */
      const { resultMsg, resultCode } = res.data || {};
      const { ret } = res;
      logData.c4 = resultCode; //  业务状态码
      logData.c5 = resultMsg; // 业务信息
      // 对编码的参数进行反编码
      logData.c3 = decodeURIComponent(logData.c3);
      let retRes = ret;
      if (ret instanceof Array) {
        retRes = ret.join(',');
      }
      // gop 状态上报
      logData.c6 = retRes;
      if (retRes && retRes.indexOf('SUCCESS') < 0) {
        logData.c7 = 'GOP_ERROR';
      }
      const status = logData.w_rc; // 网络状态码
      if (status === 200) {
        // 成功接口不上报响应结果
        logData.w_resp = undefined;
      } else if (logData.w_resp.length > 2000) {
        // 为了确保正常上报，接口异常且响应内容长度大于 2000 的只上传长度为 2000 的内容
        logData.w_resp = logData.w_resp.substring(0, 2000);
      }
      return logData;
    },
    plugins: [
      'flow',
      'perf',
      'resource',
      'blank',
      {
        id: 'jserror',
        ignoreScriptError: false,
      },
      {
        id: 'interface',
        withReqHeader: true,
        withRespHeader: true,
        withReqBody: true,
        withRespBody: true,
      },
    ],
  };
  if (isSetReady) {
    try {
      const wpk = createMonitorInstance(options);
      wpk.setReady(); // 初始化！一定记得调用
      window.wpk = wpk;
    } catch (error) {
      console.error('Failed to initialize monitor instance:', error);
    }
  }
};

export default initItrace;
